/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Conditions_DescriptionInputs */

const en_case_payment_conditions_description = /** @type {(inputs: Case_Payment_Conditions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define the negotiated amount and payment schedule.`)
};

const pt_br2_case_payment_conditions_description = /** @type {(inputs: Case_Payment_Conditions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina o valor negociado e o cronograma de pagamento.`)
};

/**
* | output |
* | --- |
* | "Define the negotiated amount and payment schedule." |
*
* @param {Case_Payment_Conditions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_conditions_description = /** @type {((inputs?: Case_Payment_Conditions_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Conditions_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_conditions_description(inputs)
	return pt_br2_case_payment_conditions_description(inputs)
});